const style = {
  borderRadius: 8
};

export function AnimeItemImage(props) {
  return (<>
    <img style={ style } src={ props.src } alt={ props.alt }/>
  </>);
}
